import { defineTextStyles } from "@chakra-ui/react";

export const textStyles = defineTextStyles({
  "2xl": {
    value: {
      fontSize: "2xl",
      lineHeight: "short",
    },
  },
  "2xs": {
    value: {
      fontSize: "2xs",
      lineHeight: "short",
    },
  },
  "3xl": {
    value: {
      fontSize: "3xl",
      lineHeight: "shorter",
    },
  },
  "4xl": {
    value: {
      fontSize: "4xl",
      lineHeight: "shorter",
    },
  },
  "5xl": {
    value: {
      fontSize: "5xl",
      lineHeight: "shorter",
    },
  },
  body: {
    value: {
      fontSize: "md",
      fontWeight: "normal",
      lineHeight: "moderate",
    },
  },
  body2: {
    value: {
      fontSize: "sm",
      fontWeight: "normal",
      lineHeight: "moderate",
    },
  },
  caption: {
    value: {
      fontSize: "xs",
      fontWeight: "normal",
      lineHeight: "short",
    },
  },
  caption2: {
    value: {
      fontSize: "2xs",
      fontWeight: "normal",
      lineHeight: "short",
    },
  },
  h1: {
    value: {
      fontSize: "5xl",
      fontWeight: "semibold",
      lineHeight: "shorter",
    },
  },
  h2: {
    value: {
      fontSize: "4xl",
      fontWeight: "semibold",
      lineHeight: "shorter",
    },
  },
  h3: {
    value: {
      fontSize: "3xl",
      fontWeight: "semibold",
      lineHeight: "shorter",
    },
  },
  h4: {
    value: {
      fontSize: "2xl",
      fontWeight: "semibold",
      lineHeight: "short",
    },
  },
  label: {
    value: {
      fontSize: "sm",
      fontWeight: "medium",
      lineHeight: "moderate",
    },
  },
  lg: {
    value: {
      fontSize: "lg",
      lineHeight: "tall",
    },
  },
  md: {
    value: {
      fontSize: "md",
      lineHeight: "moderate",
    },
  },
  sm: {
    value: {
      fontSize: "sm",
      lineHeight: "moderate",
    },
  },
  subtitle: {
    value: {
      fontSize: "md",
      fontWeight: "medium",
      lineHeight: "moderate",
    },
  },
  title: {
    value: {
      fontSize: "lg",
      fontWeight: "medium",
      lineHeight: "tall",
    },
  },
  xs: {
    value: {
      fontSize: "xs",
      lineHeight: "short",
    },
  },
});
